import React, { Component } from 'react'
import {
    Grid,
    Tabs,
    DialogActions,
    Divider,
    FormControl,
    FormControlLabel,
    Checkbox,
    TextField,
    FormGroup,
    Tooltip,
    IconButton,
    Box,
} from '@mui/material'
import LoadingDefault from '../Elements/Loading/LoadingDefault'
import { CirclePicker } from 'react-color'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { faCircle } from '@fortawesome/pro-duotone-svg-icons/faCircle'
import { faInfo } from '@fortawesome/pro-duotone-svg-icons/faInfo'
import { faSave } from '@fortawesome/pro-duotone-svg-icons/faSave'
import { faTimes } from '@fortawesome/pro-duotone-svg-icons/faTimes'
import Flag from '../../Components/Elements/Flag.tsx'
import { StyledButton } from '@/Components/Elements/StyledComponents/Buttons'
import { StyledVerticalTab } from '@/Components/Elements/StyledComponents/Tabs'
import TabPanel from '@/Components/Elements/TabPanel/TabPanel'
import {
    FormInputLabel,
    selectionControlLabelProps,
    selectionControlSx,
} from '@/Components/Elements/StyledComponents/Input'
import ObjectCreatedInfo from '@/Components/Elements/ObjectCreatedInfo'

class DefFieldListForm extends Component {
    constructor(props) {
        super(props)
        this.state = {
            translations: [],
            availableRoles: [],
            color: null,
            rank: 0,
            errors: false,
            default: false,
            settings: null,
            activeTab: 'general',
        }
        this.saveOption = this.saveOption.bind(this)
        this.fetchItem = this.fetchItem.bind(this)
        this.fetchRoles = this.fetchRoles.bind(this)
        this.onChangeRole = this.onChangeRole.bind(this)
        this.onChangeTranslationSettings =
            this.onChangeTranslationSettings.bind(this)
    }

    renderTranslations(translations) {
        const kedo = this.props.kedo
        if (!translations || translations.length <= 0) {
            translations = []
        }
        let locales = kedo.env().getEnvironmentLocales()

        if (!locales) {
            return (
                <div>
                    <p>{kedo.t('Geen talen in de omgeving ingesteld.')}</p>
                </div>
            )
        }

        return (
            <div>
                {' '}
                {locales.map((locale, index) => {
                    let trans = translations.find(
                        (item) => locale.code === item.culture
                    )
                    if (!trans) {
                        trans = {}
                    }
                    return (
                        <div key={index}>
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel>
                                    {kedo.t('Name')}{' '}
                                    <Box
                                        sx={{ display: 'inline-block', mr: 1 }}
                                    >
                                        <Flag
                                            code={locale.code.substr(
                                                locale.code.length - 2
                                            )}
                                            height="12"
                                        />
                                    </Box>
                                </FormInputLabel>
                                <TextField
                                    value={trans.text || ''}
                                    error={!!this.state.errors?.[locale]}
                                    onChange={(e) =>
                                        this.onChangeTranslation(
                                            locale.code,
                                            e.target.value
                                        )
                                    }
                                    size="small"
                                />
                            </FormControl>
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel>
                                    {kedo.t('Information text')}
                                </FormInputLabel>
                                <TextField
                                    multiline
                                    size={'small'}
                                    minRows={3}
                                    value={
                                        trans.settings?.informationtext || ''
                                    }
                                    onChange={(e) =>
                                        this.onChangeTranslationSettings(
                                            locale.code,
                                            e.target.value,
                                            'informationtext'
                                        )
                                    }
                                />
                            </FormControl>
                        </div>
                    )
                })}
            </div>
        )
    }

    fetchItem() {
        const kedo = this.props.kedo
        this.setState({ loading: true })
        kedo.api()
            .getCached(
                kedo.api().getDefFieldListEndpoint() + '/' + this.props.id
            )
            .then((response) => {
                this.fetchRoles()
                this.setState({
                    translations: response.data.translations,
                    color: response.data.color,
                    rank: response.data.rank,
                    default: response.data.default,
                    settings: response.data.settings,
                    loading: false,
                })
            })
    }

    onChangeTranslationSettings(locale, text, textKey) {
        let transes = this.state.translations

        if (!transes || transes.length <= 0) {
            transes = []
        }

        let trans = transes.find((item) => item.culture === locale)
        let transl = transes.filter((item) => item.culture !== locale)
        transes = transl
        if (!trans) {
            trans = { culture: locale, text: '', settings: {} }
        } else {
            if (!trans.settings) {
                trans.settings = {}
            } else if (Array.isArray(trans.settings)) {
                trans.settings = {}
            }
        }

        if (textKey === 'informationtext') {
            trans.settings.informationtext = text
        } else if (textKey === 'pretext') {
            trans.settings.pretext = text
        }

        transes.push(trans)

        this.setState({ translations: transes })
    }

    onChangeTranslation(locale, text) {
        let transes = this.state.translations

        if (!transes || transes.length <= 0) {
            transes = []
        }

        let trans = transes.find((item) => item.culture === locale)
        let transl = transes.filter((item) => item.culture !== locale)

        transes = transl
        if (!trans) {
            trans = { culture: locale, text: text }
        } else {
            trans.text = text
        }
        transes.push(trans)

        this.setState({ translations: transes })
    }

    saveOption() {
        const kedo = this.props.kedo
        let item = {
            color: this.state.color,
            default: this.state.default,
            defField: this.props.defFieldId,
            translations: this.state.translations,
            rank: this.state.rank,
            settings: this.state.settings,
            environment: kedo.env().getEnvironment().id,
        }

        this.setState({ addingOption: true })
        if (this.props.id) {
            kedo.api()
                .patch(
                    kedo.api().getDefFieldListEndpoint() + '/' + this.props.id,
                    item
                )
                .then((response) => {
                    if (this.props.onSuccess) {
                        this.props.onSuccess(item)
                    }
                })
        } else {
            kedo.api()
                .post(kedo.api().getDefFieldListEndpoint(), item)
                .then((response) => {
                    item.id = response.data.id
                    item.uuid = response.data.uuid
                    if (this.props.onSuccess) {
                        this.props.onSuccess(item)
                    }
                })
        }
    }

    componentDidMount() {
        if (this.props.id) {
            this.fetchItem()
        }
    }

    fetchRoles() {
        const api = this.props.kedo.api()
        this.setState({ loading: true })
        api.get(api.getRoleEndpoint(), {
            params: {
                environment: this.props.kedo.env().getEnvironment().id,
                limit: 200,
            },
        }).then((response) =>
            this.setState({
                loading: false,
                availableRoles: response.data.results,
            })
        )
    }

    onChangeRole(e) {
        let settings = this.state.settings

        if (!settings) {
            settings = {}
        }

        if (!Array.isArray(settings.roles)) {
            settings.roles = []
        }

        settings.roles = settings.roles.filter(
            (roleId) => e.target.value != roleId
        )

        if (e.target.checked) {
            settings.roles.push(parseInt(e.target.value))
        }

        this.setState({ settings: settings })
    }

    render() {
        if (!this.props.defFieldId) {
            return ''
        }
        const kedo = this.props.kedo

        if (this.state.loading) {
            return <LoadingDefault />
        }

        return (
            <>
                <Grid container>
                    <Grid
                        size={3}
                        sx={{ borderRight: 1, borderColor: 'divider' }}
                    >
                        <Tabs
                            value={this.state.activeTab}
                            orientation="vertical"
                            onChange={(event, newValue) =>
                                this.setState((prevState) => ({
                                    ...prevState,
                                    activeTab: newValue,
                                }))
                            }
                            sx={{ '& .MuiTabs-indicator': { display: 'none' } }}
                        >
                            <StyledVerticalTab
                                label={kedo.t('Generic')}
                                value="general"
                            />
                            <StyledVerticalTab
                                label={kedo.t('Layout')}
                                value="layout"
                            />
                            <StyledVerticalTab
                                label={kedo.t('Visibility')}
                                value="visibility"
                            />
                            <StyledVerticalTab
                                label={kedo.t('Info')}
                                value="info"
                            />
                        </Tabs>
                    </Grid>
                    <Grid size={9}>
                        <TabPanel value={this.state.activeTab} index="general">
                            {this.renderTranslations(this.state.translations)}
                            <FormControlLabel
                                {...selectionControlLabelProps}
                                control={
                                    <Checkbox
                                        size="small"
                                        sx={selectionControlSx}
                                        key={`list-option-default`}
                                        name={'default'}
                                        checked={this.state.default}
                                        onChange={() =>
                                            this.setState({
                                                default: !this.state.default,
                                            })
                                        }
                                    />
                                }
                                label={kedo.t('Default')}
                            />
                        </TabPanel>
                        <TabPanel value={this.state.activeTab} index={'layout'}>
                            <h3>{kedo.t('Layout')}</h3>
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel>
                                    {kedo.t('Color')}
                                </FormInputLabel>
                                {this.state.color ? (
                                    <span>
                                        &nbsp;{' '}
                                        <FontAwesomeIcon
                                            style={{
                                                color: this.state.color,
                                            }}
                                            icon={faCircle}
                                        />
                                        &nbsp;
                                    </span>
                                ) : null}
                                {this.state.color ? (
                                    <IconButton
                                        size={'small'}
                                        onClick={() => {
                                            this.setState({ color: null })
                                        }}
                                        title={'Clear'}
                                    >
                                        <FontAwesomeIcon icon={faTimes} />
                                    </IconButton>
                                ) : null}
                            </FormControl>
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel>
                                    {kedo.t('Choose an option')}
                                </FormInputLabel>
                                <CirclePicker
                                    value={this.state.color}
                                    onChangeComplete={(color, event) => {
                                        this.setState({ color: color.hex })
                                    }}
                                />
                            </FormControl>
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel>
                                    {kedo.t('Rank')}
                                </FormInputLabel>

                                <TextField
                                    type="number"
                                    size={'small'}
                                    value={this.state.rank}
                                    error={!!this.state.errors?.rank}
                                    inputProps={{ min: 0 }}
                                    onChange={(e) =>
                                        this.setState({ rank: e.target.value })
                                    }
                                />
                            </FormControl>
                        </TabPanel>
                        <TabPanel
                            value={this.state.activeTab}
                            index="visibility"
                        >
                            <h3>{kedo.t('Visibility')}</h3>
                            <FormControl fullWidth margin="normal">
                                <FormInputLabel>
                                    {kedo.t('Roles')}
                                    <Tooltip
                                        title={kedo.t(
                                            'Select role(s) to hide this specific option'
                                        )}
                                    >
                                        <IconButton
                                            size="small"
                                            color="info"
                                            sx={{
                                                ml: 0.75,
                                                pb: 1.5,
                                                fontSize: '1rem',
                                            }}
                                        >
                                            <FontAwesomeIcon icon={faInfo} />
                                        </IconButton>
                                    </Tooltip>
                                </FormInputLabel>
                                <FormGroup>
                                    {this.state.availableRoles.map((item) => (
                                        <FormControlLabel
                                            key={item.id}
                                            label={item.name}
                                            {...selectionControlLabelProps}
                                            control={
                                                <Checkbox
                                                    size="small"
                                                    sx={selectionControlSx}
                                                    checked={this.state.settings?.roles?.includes(
                                                        item.id
                                                    )}
                                                    value={item.id}
                                                    onChange={this.onChangeRole}
                                                />
                                            }
                                        />
                                    ))}
                                </FormGroup>
                            </FormControl>
                        </TabPanel>
                        <TabPanel value={this.state.activeTab} index="info">
                            <h3>{this.props.kedo.t('Info')}</h3>
                            <ObjectCreatedInfo
                                kedo={this.props.kedo}
                                item={this.props.kedo.env().getEnvironment()}
                            />
                        </TabPanel>
                    </Grid>
                </Grid>

                <Divider />
                <DialogActions sx={{ p: 2 }}>
                    <StyledButton onClick={this.saveOption}>
                        {this.state.addingOption ? (
                            <LoadingDefault as={'span'} />
                        ) : (
                            <FontAwesomeIcon icon={faSave} />
                        )}
                        &nbsp; {this.props.kedo.t('Save')}
                    </StyledButton>
                    &nbsp;
                    <StyledButton
                        color={'secondary'}
                        onClick={this.props.onClose}
                    >
                        {kedo.t('Cancel')}
                    </StyledButton>
                </DialogActions>
            </>
        )
    }
}

export default DefFieldListForm
